import { Chart } from './Chart.js';
import { jsx } from 'react/jsx-runtime';
import { useTheme, useThemeSeriesColors } from '@shopify/polaris-viz-core';

function VerticalBarChart({
  annotationsLookupTable = {},
  data,
  dimensions,
  emptyStateText,
  renderLegendContent,
  renderTooltipContent,
  showLegend,
  type = 'default',
  xAxisOptions,
  yAxisOptions
}) {
  const selectedTheme = useTheme();
  const seriesColors = useThemeSeriesColors(data, selectedTheme);
  const seriesWithDefaults = data.map((series, index) => ({
    color: seriesColors[index],
    ...series
  }));
  return /*#__PURE__*/jsx(Chart, {
    dimensions: dimensions,
    annotationsLookupTable: annotationsLookupTable,
    data: seriesWithDefaults,
    emptyStateText: emptyStateText,
    renderLegendContent: renderLegendContent,
    renderTooltipContent: renderTooltipContent,
    showLegend: showLegend,
    type: type,
    xAxisOptions: xAxisOptions,
    yAxisOptions: yAxisOptions
  });
}

export { VerticalBarChart };
